//date formatery

export function formatDateForBackend(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * Parsuje UTC timestamp z DB ako UTC (aj keď nemá 'Z').
 * Vracia objekt Date alebo null.
 */
export function parseDbUtcDate(dbTimestamp) {
  if (!dbTimestamp) return null;
  const str = String(dbTimestamp);
  const utcStr = /[Zz]$|[+-]\d{2}:\d{2}$/.test(str) ? str : str.replace(" ", "T") + "Z";
  const d = new Date(utcStr);
  return isNaN(d.getTime()) ? null : d;
}
